import styled from 'styled-components';
import { Col, Row as UiToolKitRow, Grid } from '@mlc/web-ui-toolkit';
import { ScreenSize } from '../../../enums';

export const Column = styled(Col)`
	display: flex;
	padding-left: 15px;
	padding-right: 15px;
`;

export const Wrapper = styled.div`
	padding: 10px 0;
`;

export const Row = styled(UiToolKitRow)`
	margin: 0 -15px;
	padding-bottom: 10px;
`;

export const ContentGrid = styled(Grid)`
	display: flex;
	flex-basis: 100%;
	flex-grow: 0;
	flex-shrink: 0;
	max-width: 1010px;
	width: 100%;

	& > .Grid__container {
		padding: 0 15px;
	}

	@media (min-width: ${ScreenSize.xSmall}) {
		max-width: 540px;
	}

	@media (min-width: ${ScreenSize.small}) {
		max-width: 720px;
	}

	@media (min-width: ${ScreenSize.medium}) {
		max-width: 960px;
	}

	@media (min-width: ${ScreenSize.large}) {
		max-width: 1010px;
		padding: 0;
	}
`;

export const ContainerDiv = styled('div')<{ background: string }>`
	background-color: ${props => props.background};
	display: flex;
	flex: 1;
	justify-content: center;

	.Grid__container {
		position: initial;
	}
`;
